module.exports = __webpack_public_path__ + "static/media/dataPointLogo_xl.33d8e44f.svg";